<template>
  <div class="timeline_content">
    <el-timeline v-if="datas.length > 0 && Array.isArray(data)" style="max-width: 600px">
      <el-timeline-item
        v-for="(_item, index) in data"
        :key="index"
        :color="item.options?.props?.color || '#409eff'"
        :icon="item.options?.props?.icon || 'el-icon-select'"
        :type="item.options?.props?.type || 'primary'"
      >
        <h4>
          {{ item.options.statusText || "审核结果：" }}
          <el-tag size="large" :type="_item[item.options?.props?.status] == 'approved' ? item.options.statusType : 'danger'">
            {{ timeline(item.options.items, _item[item.options?.props?.status]) }}
          </el-tag>
        </h4>
        <h4>{{ item.options.titleText || "审核意见：" }}{{ _item[item.options?.props?.title] }}</h4>
        <p>{{ item.options.subTitleText || "审核时间：" }}{{ _item[item.options?.props?.subTitle] }}</p>
      </el-timeline-item>
    </el-timeline>
    <div v-else>暂无</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => {
        return {
          options: {
            props: {
              color: "#409eff",
              icon: "el-icon-select",
              type: "primary",
              status: "",
              title: "",
              subTitle: ""
            },
            statusText: "审核结果",
            titleText: "审核意见",
            subTitleText: "审核意见"
          }
        }
      }
    }
  },
  data() {
    return { datas: [] }
  },
  mounted() {
    this.init()
  },
  watch: {
    data: {
      handler(val) {
        // console.log('dbTimeLine======',val)
        this.datas = val
      },
      deep: true
    }
  },
  methods: {
    init() {
      this.datas = this.data
      // console.log("传入数据", this.data)
    },
    timeline(data, value) {
      const res = data?.filter((item) => item.value == value)
      return res[0]?.label
    }
  }
}
</script>

<style lang="scss" scoped>
.timeline_content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}
</style>
